import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TagRemoveIcon } from "../icons.js";
import * as styles from "./Tag.css.js";
// A user-defined free-text tag (T29). Not to be confused with `AssignmentChip`, the
// fixed everyone/shared pill: this one carries whatever the user typed, and the set of
// tags is derived from the rows themselves rather than from a registry.
export const Tag = ({ label, selected = false, onClick, onRemove, size = "sm" }) => {
    const className = [
        styles.base,
        styles.size[size],
        selected ? styles.selected : "",
        onClick !== undefined ? styles.clickable : "",
    ]
        .filter(Boolean)
        .join(" ");
    const removeButton = onRemove !== undefined ? (_jsx("button", { type: "button", className: styles.remove, "aria-label": `Remove tag ${label}`, onClick: onRemove, children: _jsx(TagRemoveIcon, {}) })) : undefined;
    // A chip with an onRemove is a <span> wrapper even when clickable, since a button
    // may not nest inside a button.
    if (onClick !== undefined && onRemove === undefined) {
        return (_jsx("button", { type: "button", className: className, "aria-pressed": selected, onClick: onClick, children: label }));
    }
    return (_jsxs("span", { className: className, onClick: onClick, role: onClick !== undefined ? "button" : undefined, children: [label, removeButton] }));
};
//# sourceMappingURL=Tag.js.map